import {Redirect} from "expo-router";
import {PropsWithChildren} from "react";
import {useAuth} from "@/auth/useAuth";

export function UnAuthenticated({children}: PropsWithChildren) {
    const {isAuthenticated, isLoading} = useAuth();

    // Wait for auth state to be determined
    if (isLoading) {
        return null;
    }

    if (isAuthenticated) {
        return <Redirect href={'/'} />
    }

    return <>{children}</>;
}
